import { render, staticRenderFns } from "./MainModeLatestPaperList.vue?vue&type=template&id=5ac79e45&scoped=true&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeEvents/components/MainModeLatestPaperList?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeEvents/components/MainModeLatestPaperList?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac79e45",
  null
  
)

export default component.exports